// Mock data for development without API

// Mock appointments
export const mockAppointments = [
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    customerId: 'a1b2c3d4-e5f6-4a5b-9c3d-6e7f8a9b0c1d',
    customerName: 'John Doe',
    teamMemberId: 'b2c3d4e5-f6a7-5b6c-0d1e-2f3a4b5c6d7e',
    teamMemberName: 'Mike Johnson',
    serviceId: 'c3d4e5f6-a7b8-6c7d-1e2f-3a4b5c6d7e8f',
    serviceName: 'Haircut',
    startTime: '2023-11-15T10:00:00',
    endTime: '2023-11-15T10:30:00',
    status: 'Confirmed',
    price: 25.00
  },
  {
    id: '4fa85f64-5717-4562-b3fc-2c963f66afa7',
    customerId: 'd4e5f6a7-b8c9-7d8e-0f1a-2b3c4d5e6f7a',
    customerName: 'Jane Smith',
    teamMemberId: 'e5f6a7b8-c9d0-8e9f-1a2b-3c4d5e6f7a8b',
    teamMemberName: 'Sarah Williams',
    serviceId: 'f6a7b8c9-d0e1-9f0a-2b3c-4d5e6f7a8b9c',
    serviceName: 'Hair Coloring',
    startTime: '2023-11-15T11:00:00',
    endTime: '2023-11-15T12:30:00',
    status: 'Confirmed',
    price: 60.00
  },
  {
    id: '5fa85f64-5717-4562-b3fc-2c963f66afa8',
    customerId: 'a7b8c9d0-e1f2-0a1b-3c4d-5e6f7a8b9c0d',
    customerName: 'Robert Johnson',
    teamMemberId: 'b2c3d4e5-f6a7-5b6c-0d1e-2f3a4b5c6d7e',
    teamMemberName: 'Mike Johnson',
    serviceId: 'b8c9d0e1-f2a3-1b2c-4d5e-6f7a8b9c0d1e',
    serviceName: 'Beard Trim',
    startTime: '2023-11-15T13:00:00',
    endTime: '2023-11-15T13:15:00',
    status: 'Pending',
    price: 15.00
  },
  {
    id: '6fa85f64-5717-4562-b3fc-2c963f66afa9',
    customerId: 'c9d0e1f2-a3b4-2c3d-5e6f-7a8b9c0d1e2f',
    customerName: 'Emily Davis',
    teamMemberId: 'd0e1f2a3-b4c5-3d4e-6f7a-8b9c0d1e2f3a',
    teamMemberName: 'John Smith',
    serviceId: 'e1f2a3b4-c5d6-4e5f-7a8b-9c0d1e2f3a4b',
    serviceName: 'Haircut & Beard',
    startTime: '2023-11-16T09:30:00',
    endTime: '2023-11-16T10:15:00',
    status: 'Confirmed',
    price: 35.00
  },
  {
    id: '7fa85f64-5717-4562-b3fc-2c963f66afaa',
    customerId: 'e1f2a3b4-c5d6-4e5f-7a8b-9c0d1e2f3a4b',
    customerName: 'Michael Brown',
    teamMemberId: 'e5f6a7b8-c9d0-8e9f-1a2b-3c4d5e6f7a8b',
    teamMemberName: 'Sarah Williams',
    serviceId: 'f2a3b4c5-d6e7-5f6a-8b9c-0d1e2f3a4b5c',
    serviceName: 'Hot Towel Shave',
    startTime: '2023-11-16T11:00:00',
    endTime: '2023-11-16T11:30:00',
    status: 'Cancelled',
    price: 30.00
  }
];

// Mock services
export const mockServices = [
  {
    id: 'c3d4e5f6-a7b8-6c7d-1e2f-3a4b5c6d7e8f',
    name: 'Haircut',
    description: 'Standard haircut with styling',
    duration: 30,
    price: 25.00,
    isActive: true
  },
  {
    id: 'f6a7b8c9-d0e1-9f0a-2b3c-4d5e6f7a8b9c',
    name: 'Hair Coloring',
    description: 'Full hair coloring service',
    duration: 90,
    price: 60.00,
    isActive: true
  },
  {
    id: 'b8c9d0e1-f2a3-1b2c-4d5e-6f7a8b9c0d1e',
    name: 'Beard Trim',
    description: 'Beard shaping and trimming',
    duration: 15,
    price: 15.00,
    isActive: true
  },
  {
    id: 'e1f2a3b4-c5d6-4e5f-7a8b-9c0d1e2f3a4b',
    name: 'Haircut & Beard',
    description: 'Haircut with beard trim combo',
    duration: 45,
    price: 35.00,
    isActive: true
  },
  {
    id: 'f2a3b4c5-d6e7-5f6a-8b9c-0d1e2f3a4b5c',
    name: 'Hot Towel Shave',
    description: 'Traditional hot towel straight razor shave',
    duration: 30,
    price: 30.00,
    isActive: true
  }
];

// Mock teamMembers (barbers)
export const mockTeamMembers = [
  {
    id: 'b2c3d4e5-f6a7-5b6c-0d1e-2f3a4b5c6d7e',
    firstName: 'Mike',
    lastName: 'Johnson',
    email: 'mike.johnson@salovare.com',
    phone: '555-123-4567',
    position: 'Senior Barber',
    specialties: ['Haircut', 'Beard Trim', 'Hot Towel Shave'],
    isActive: true
  },
  {
    id: 'e5f6a7b8-c9d0-8e9f-1a2b-3c4d5e6f7a8b',
    firstName: 'Sarah',
    lastName: 'Williams',
    email: 'sarah.williams@salovare.com',
    phone: '555-234-5678',
    position: 'Master Stylist',
    specialties: ['Haircut', 'Hair Coloring'],
    isActive: true
  },
  {
    id: 'd0e1f2a3-b4c5-3d4e-6f7a-8b9c0d1e2f3a',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@salovare.com',
    phone: '555-345-6789',
    position: 'Barber',
    specialties: ['Haircut', 'Beard Trim', 'Haircut & Beard'],
    isActive: true
  }
];

// Mock customers
export const mockCustomers = [
  {
    id: 'a1b2c3d4-e5f6-4a5b-9c3d-6e7f8a9b0c1d',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '555-111-2222',
    address: {
      street: '123 Main St',
      city: 'Anytown',
      state: 'CA',
      zipCode: '12345'
    },
    notes: 'Prefers classic cuts'
  },
  {
    id: 'd4e5f6a7-b8c9-7d8e-0f1a-2b3c4d5e6f7a',
    firstName: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@example.com',
    phone: '555-222-3333',
    address: {
      street: '456 Oak Ave',
      city: 'Somewhere',
      state: 'NY',
      zipCode: '67890'
    },
    notes: 'Allergic to certain hair products'
  },
  {
    id: 'a7b8c9d0-e1f2-0a1b-3c4d-5e6f7a8b9c0d',
    firstName: 'Robert',
    lastName: 'Johnson',
    email: 'robert.johnson@example.com',
    phone: '555-333-4444',
    address: {
      street: '789 Pine Rd',
      city: 'Elsewhere',
      state: 'TX',
      zipCode: '54321'
    },
    notes: 'Monthly beard trim'
  },
  {
    id: 'c9d0e1f2-a3b4-2c3d-5e6f-7a8b9c0d1e2f',
    firstName: 'Emily',
    lastName: 'Davis',
    email: 'emily.davis@example.com',
    phone: '555-444-5555',
    address: {
      street: '321 Elm Blvd',
      city: 'Nowhere',
      state: 'FL',
      zipCode: '98765'
    },
    notes: ''
  },
  {
    id: 'e1f2a3b4-c5d6-4e5f-7a8b-9c0d1e2f3a4b',
    firstName: 'Michael',
    lastName: 'Brown',
    email: 'michael.brown@example.com',
    phone: '555-555-6666',
    address: {
      street: '654 Maple Dr',
      city: 'Anyplace',
      state: 'WA',
      zipCode: '13579'
    },
    notes: 'Prefers appointments in the morning'
  }
];

// Mock user for authentication
export const mockUser = {
  id: '9fa85f64-5717-4562-b3fc-2c963f66afab',
  email: 'admin@salovare.com',
  firstName: 'Admin',
  lastName: 'User',
  role: 'Admin'
};

// Mock token
export const mockToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5ZmE4NWY2NC01NzE3LTQ1NjItYjNmYy0yYzk2M2Y2NmFmYWIiLCJuYW1lIjoiQWRtaW4gVXNlciIsInJvbGUiOiJBZG1pbiIsImV4cCI6MTk5OTk5OTk5OX0.signature'; 